import { cartCommon, cartSearchForm, cartResult, addToCartMessage } from './draft-order.i18n';
import {
  quoteCommon,
  quoteSearchForm,
  quoteResult,
  actionBar,
  quoteDetailHeader,
  quoteItems,
  quotePartialItems,
  quoteReference,
  addToQuoteMessage,
} from './quote.i18n';

export const savedCart = {
  /* Quote translation */
  quoteCommon,
  quoteSearchForm,
  quoteResult,
  actionBar,
  quoteDetailHeader,
  quoteItems,
  quotePartialItems,
  quoteReference,
  addToQuoteMessage,

  /* Draftorder translation */
  cartCommon,
  cartSearchForm,
  cartResult,
  addToCartMessage,
};
